import type { StyleProps } from "@chakra-ui/react";
import { Progress as ChakraProgress } from "@chakra-ui/react";
import type { ThemeColors } from "../../theme/tokens/colors";

export interface ProgressProps extends StyleProps {
  value: number;
  color: ThemeColors | string;
  isIndeterminate?: boolean;
  isAnimated?: boolean;
  inverted?: boolean;
}

/**
 * Shows measurable progress for a task or operation. Progress Bars help users
 * understand how much of a known process has completed and how much remains.
 * If progress is unknown, use Loader; for multi-step flows, use Stepper.
 */
export const Progress = ({
  value,
  color,
  isIndeterminate = false,
  isAnimated = false,
  inverted = false,
  ...customStyles
}: ProgressProps) => {
  const indeterminateBg = inverted ? "highlight.emphasized" : "highlight.muted";
  const determinateBg = inverted ? "bg.container" : "bg.container";
  return (
    <ChakraProgress
      size="xs"
      value={value}
      color={color}
      bg={isIndeterminate ? indeterminateBg : determinateBg}
      isIndeterminate={isIndeterminate}
      borderRadius="sm"
      {...(isAnimated && {
        sx: {
          '& > div[role="progressbar"]': {
            transition: "width 0.3s ease-in-out",
          },
        },
      })}
      {...customStyles}
    />
  );
};
